import React from 'react';
import { useForm } from 'react-hook-form';

import { ReactComponent as ArrowNextIcon } from '@assets/svg/arrow-next.svg';

import Button from '@components/uikit/Button/Button';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import { usePrivacyPolicySetSettingsMutation } from '@services/usePrivacyPolicySetSettingsMutation';

import { useModalActions } from '@store/useModalStore';

import ModalHeader from '../ModalHeader/ModalHeader';
import SettingItem from './components/SettingItem/SettingItem';
import { collapseModalItems } from './constants/collapseModalItems';
import style from './style.module.scss';

const defValues = {
  strictly_necessary: 1,
  functionality: 0,
  tracking_performance: 0,
  targeting: 0,
};

const PrivacyPolicySettingsModal = () => {
  const { t } = useTranslation();

  const { setModalClose, setActiveModal } = useModalActions();

  const { mutate: privacyPolicySetSettingsMutate, isLoading: privacyPolicySetSettingsLoading } =
    usePrivacyPolicySetSettingsMutation();

  const { control, handleSubmit } = useForm({ defaultValues: defValues });

  const submit = (isAll) =>
    handleSubmit((data) =>
      privacyPolicySetSettingsMutate(
        {
          privacy_data: {
            strictly_necessary: +data.strictly_necessary,
            functionality: isAll ? 1 : +data.functionality,
            tracking_performance: isAll ? 1 : +data.tracking_performance,
            targeting: isAll ? 1 : +data.targeting,
          },
        },
        {
          onSuccess: () => {
            setModalClose();
          },
        },
      ),
    )();

  const handleOpenMainPrivacyModal = () => setActiveModal({ name: MODAL_NAMES.privacyPolicyModal });

  return (
    <div className={style.modalPolicySettings}>
      <ModalHeader
        title={'configure your privacy'}
        onClose={handleOpenMainPrivacyModal}
      />
      <div className={style.modalBody}>
        <div className={style.settingsText}>
          {t(
            'When you visit any web site, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience.',
          )}
          <a className={style.policyLink} href={APP_SSO_URL + 'privacy'} target="_blank">
            {' '}
            {t('Read the privacy policy.')}
          </a>
        </div>
        <div className={style.formWrapper}>
          {collapseModalItems.map((item) => (
            <SettingItem key={item.name} item={item} control={control} />
          ))}
        </div>
      </div>
      <div className={style.modalFooter}>
        <Button type="secondary" text={t('Cancel')} onClick={handleOpenMainPrivacyModal} />
        <Button
          type="outline"
          variant={'medium'}
          text={t('Save Settings')}
          disabled={privacyPolicySetSettingsLoading}
          onClick={() => submit()}
        />
        <Button
          type="primary"
          variant={'medium'}
          text={t('Accept All')}
          disabled={privacyPolicySetSettingsLoading}
          onClick={() => submit('all')}
        />
      </div>
    </div>
  );
};

export default PrivacyPolicySettingsModal;
